/** Tooltip copy for management dashboard — see Docs/.../Sales/HELP-TOOLTIPS.md */

export const managementHelp = {
  page: {
    title: 'Sales & Enrollment',
    body: 'Overview of leads, demos, enrollments, and payments for the selected period. Times are in India Standard Time (IST). Only admins can view this page.',
  },
  dateFilter: {
    title: 'Date range',
    body: 'Filters most sections to activity between the chosen dates. Weeks run Monday–Sunday in IST. Compare lines on the top cards use the previous period of the same length.',
  },
  pulse: {
    leadToEnrollment: {
      title: 'Lead → Enrollment',
      body: 'Of leads acquired in this period, how many were marked Won in the same period. This is the true cohort conversion rate.',
      activity: {
        title: 'All wins this period',
        body: 'Every lead marked Won during this period for the assigned sales owner (or source/country), including leads acquired before this period. Can exceed cohort conversion when closing older pipeline.',
      },
    },
    revenue: {
      title: 'Revenue',
      body: 'Total payments marked Paid in Finance during this period. The comparison line shows the previous period of the same length.',
    },
    enrollments: {
      title: 'Enrollments',
      body: 'Leads marked Won during this period (from status history). May include leads acquired in an earlier month. This is a count of enrollments, not payment status.',
    },
    health: {
      title: 'Health status',
      body: 'A traffic-light summary: Excellent / Good = on track. Needs attention = review soon. Poor = action likely needed.',
    },
  },
  funnel: {
    section: {
      title: 'Sales funnel',
      body: 'Cohort funnel follows leads acquired in this period through demo and enrollment. Activity counts below are independent in-period events (not the same cohort).',
    },
    cohort: {
      title: 'Cohort funnel',
      body: 'Starts with leads acquired in the selected period. Each step is a subset of those same leads: invited to a demo, attended a completed demo, then marked Won in the same period.',
    },
    activity: {
      title: 'Activity in period',
      body: 'Separate counts of what happened during the dates selected — demos scheduled, demos attended, all wins, etc. These can differ from the cohort funnel because dates and populations differ.',
    },
    leads_created: { title: 'Leads created', body: 'New leads in this period using lead acquired date. Deleted leads are excluded.' },
    demos_scheduled: { title: 'Demos scheduled', body: 'Distinct leads added to a demo or trial (not cancelled) in this period.' },
    demos_attended: {
      title: 'Demos attended',
      body: 'Leads on a completed demo in this period who did not have status Demo not present. Attendance may be estimated until recorded per lead at demo close.',
    },
    enrollments: { title: 'Enrollments', body: 'Leads marked Won in this period.' },
    payments: { title: 'Payments received', body: 'Payments marked Paid in Finance during this period.' },
  },
  ageing: {
    section: {
      title: 'Stuck after demo',
      body: 'Live snapshot as of today — not limited by the date filter above. Parents who had a completed demo but have not enrolled. Days waiting = days since the demo scheduled date.',
    },
    buckets: {
      title: 'Follow-up age',
      body: 'How long since the latest completed demo. Leads in 15+ days usually need an urgent follow-up call.',
    },
  },
  sources: {
    title: 'Lead sources',
    body: 'Leads acquired in this period by source group. Conversion uses enrollments from those same leads (Won in period). Click Leads / Enrolled counts to open the Lead List with matching filters. Demo / Trial shows attended session breakdown for those leads.',
    activity: {
      title: 'All wins this period',
      body: 'All leads marked Won in this period for that source, including leads acquired in earlier months. Click the count to open those enrolled leads.',
    },
  },
  countries: {
    title: 'Countries',
    body: 'Leads acquired in this period by country. Conversion uses enrollments from those same leads (Won in period). Click counts to open the filtered Lead List. Demo / Trial splits attended sessions for those leads.',
    activity: {
      title: 'All wins this period',
      body: 'All leads marked Won in this period for that country, including leads acquired in earlier months. Click the count to open those enrolled leads.',
    },
  },
  sales: {
    title: 'Sales team',
    body: 'Leads acquired in this period per sales owner (current assignment). Conversion = those leads marked Won in the same period. Click counts to open the Lead List. Demo / Trial shows attended session breakdown.',
    activity: {
      title: 'All wins this period',
      body: 'All leads marked Won this period for that owner, including pipeline from earlier months. Assignment uses current owner on the lead. Click the count to open those leads.',
    },
  },
  trainers: {
    title: 'Trainers',
    body: 'Completed demos/trials in this period. Attended = distinct students who attended. Enrolled = those attendees who are Won (any time). Conversion = enrolled ÷ attended. Click Attended / Enrolled to open the Lead List. Demo / Trial splits the same metrics by session type.',
    closedThisMonth: {
      title: 'Closed this month',
      body: 'Among students who attended this trainer’s demos in the selected period, how many were marked Won during the same period. Click the count to open those leads.',
    },
  },
  trend: {
    title: 'Revenue trend',
    body: 'Paid payments and enrollments over time. Bucket size follows your date range.',
  },
};

export default managementHelp;
